/**
 * Custom Node Component
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Code } from 'lucide-react';
import styles from './Nodes.module.css';

export const CustomNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.customNode} ${selected ? styles.selected : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
      />
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#ec4899' }}>
          <Code size={16} color="white" />
        </div>
        <div className={styles.nodeDetails}>
          <span className={styles.nodeLabel}>{data.label || 'Custom'}</span>
          {data.language && (
            <span className={styles.nodeSubtitle}>{data.language}</span>
          )}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={styles.handle}
      />
    </div>
  );
});

CustomNode.displayName = 'CustomNode';
